import { render, staticRenderFns } from "./TableBetValues.vue?vue&type=template&id=b9c51ece&scoped=true"
import script from "./TableBetValues.vue?vue&type=script&lang=js"
export * from "./TableBetValues.vue?vue&type=script&lang=js"
import style0 from "./TableBetValues.vue?vue&type=style&index=0&id=b9c51ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c51ece",
  null
  
)

export default component.exports